import React, { useState } from 'react';
import './App.css';
import { Instagram } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  Alert,
  Chip
} from '@mui/material';
import {
  Phone,
  Email,
  LocationOn,
  Send
} from '@mui/icons-material';
import { submitContactForm } from './firebase/database';
import { getMergedSiteContent } from './firebase/tenants';

function HomePage({ tenant }) {
  const navigate = useNavigate();
  const siteName = tenant?.branding?.siteName || tenant?.name || 'DE MUSCLE FACTORY';
  const content = getMergedSiteContent(tenant);
  const hero = content.hero || {};
  const timings = content.timings || {};
  const about = content.about || {};
  const classes = content.classes || {};
  const cta = content.cta || {};
  const trainers = content.trainers || {};
  const pricing = content.pricing || {};
  const becomeTrainer = content.becomeTrainer || {};
  const contact = content.contact || {};
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    inquiryType: 'general'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitMessage = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const contactData = {
        ...formData,
        timestamp: Date.now(),
        submissionDate: new Date().toISOString(),
        status: 'new'
      };

      if (!tenant?.id) {
        setSubmitStatus('error');
        return;
      }
      const result = await submitContactForm(tenant.id, contactData);

      if (result.success) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          inquiryType: 'general'
        });
      } else {
        console.error('Submit failed:', result.message);
        setSubmitStatus('error');
      }

    } catch (error) {
      console.error('Error submitting contact form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBecomeTrainer = () => {
    setFormData(prev => ({ ...prev, inquiryType: 'trainer' }));
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const handleJoinTeam = () => {
    setFormData(prev => ({ ...prev, inquiryType: 'team' }));
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      {/* Navigation Header */}
      <header className="navbar">
        <div className="nav-container">
          <div className="logo">
            {tenant?.branding?.logoUrl ? (
              <img src={tenant.branding.logoUrl} alt={siteName} className="logo-img" />
            ) : (
              <div className="logo-icon">💪</div>
            )}
            <span className="logo-text" style={{ textTransform: 'uppercase' }}>{siteName}</span>
          </div>
          <nav className="nav-menu">
            <a href="#home" className="nav-link active" onClick={handleHomeClick}>Home</a>
            <a href="#timings" className="nav-link">Timings</a>
                            {/* <a href="#pages" className="nav-link">Pages</a> */}
                {/* <a href="#class" className="nav-link">Class</a> */}
                <a href="#contact" className="nav-link">Contact</a>
                {/* <a href="/adminlogin" className="nav-link">Admin</a> */}
          </nav>
          {/* <div className="nav-actions">
            <button className="join-btn">+ JOIN CLASS NOW</button>
          </div> */}
        </div>
      </header>

      {/* Hero Section */}
      <main className="hero-section">
        <div className="hero-container">
          {/* Social Media Links */}
         
          {/* Hero Content */}
          <div className="hero-content">
            <div className="hero-text">
              <div className="tagline">{hero.tagline || 'FIND YOUR ENERGY'}</div>
              <h1 className="hero-title">
                <div className="title-line-1">{hero.titleLine1 || 'MAKE YOUR BODY'}</div>
                <div className="title-line-2"><span className="title-highlight">{hero.titleLine2 || 'FIT & PERFECT'}</span></div>
              </h1>
              <p className="hero-description">
                {Array.isArray(hero.descriptionLines) && hero.descriptionLines.length > 0
                  ? hero.descriptionLines.map((line, i) => <div key={i} className="desc-line">{line}</div>)
                  : (
                    <>
                      <div className="desc-line">Transform Your Body Into A Powerhouse</div>
                      <div className="desc-line">Where Strength Meets Determination</div>
                      <div className="desc-line">Build The Ultimate Version Of Yourself</div>
                    </>
                  )}
              </p>
            </div>
          </div>


        </div>
      </main>

      {/* Gym Timings Section */}
      <section id="timings" className="gym-timings-section">
        <div className="container">
          <div className="timings-header">
            <h2 className="gym-name">{siteName}</h2>
            <span className="gym-type">{timings.gymType || '(UNISEX GYM)'}</span>
            <p className="gym-subtitle">{timings.subtitle || 'The Gym With The Motive'}</p>
          </div>
          <div className="timings-content">
            <div className="timings-card">
              <h3 className="timings-title">🕐 GYM TIMINGS</h3>
              <div className="timing-slots">
                {Array.isArray(timings.slots) && timings.slots.length > 0
                  ? timings.slots.map((slot, i) => (
                      <div key={i} className={`timing-slot ${slot.typeClass || 'unisex'}`}>
                        <div className="time-period">{slot.period}</div>
                        <div className={`session-type ${(slot.typeClass || 'unisex') === 'female' ? 'female-session' : 'unisex-session'}`}>{slot.type}</div>
                      </div>
                    ))
                  : (
                    <>
                      <div className="timing-slot unisex"><div className="time-period">5:00 AM - 8:30 AM</div><div className="session-type unisex-session">UNISEX</div></div>
                      <div className="timing-slot female"><div className="time-period">8:30 AM - 11:30 AM</div><div className="session-type female-session">ONLY FEMALE</div></div>
                      <div className="timing-slot unisex"><div className="time-period">11:30 AM - 3:00 PM</div><div className="session-type unisex-session">UNISEX</div></div>
                      <div className="timing-slot female"><div className="time-period">3:00 PM - 5:15 PM</div><div className="session-type female-session">ONLY FEMALE</div></div>
                      <div className="timing-slot unisex"><div className="time-period">5:00 PM - 11:00 PM</div><div className="session-type unisex-session">UNISEX</div></div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <span className="section-tag">{about.tag || 'GYM FITNESS'}</span>
              <span className="section-subtitle">About {siteName}</span>
              <h2 className="section-title">{about.title || 'Transform Your Body Into a Muscle Factory!'}</h2>
              <p className="section-description">{about.description || 'Our gym is where strength meets innovation.'}</p>
              <div className="stats">
                <div className="stat">
                  <span className="stat-number">{about.stat1?.number ?? '1500'}</span>
                  <span className="stat-plus">{about.stat1?.suffix ?? '+'}</span>
                  <span className="stat-label">{about.stat1?.label ?? 'Trained People'}</span>
                </div>
                <div className="stat">
                  <span className="stat-number">{about.stat2?.number ?? '100'}</span>
                  <span className="stat-plus">{about.stat2?.suffix ?? '+'}</span>
                  <span className="stat-label">{about.stat2?.label ?? 'Modern Equipment'}</span>
                </div>
              </div>
              <p className="about-description">{about.secondParagraph || 'Our cutting-edge equipment and personalized training programs are designed to maximize your potential.'}</p>
            </div>
            <div className="about-image">
              <img src={about.imageUrl || 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'} alt="Gym Equipment and Training" className="about-img" />
              <div className="about-overlay"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Classes Section */}
      <section className="classes-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">{siteName} {classes.subtitleSuffix || 'Services'}</span>
            <h2 className="section-title">{classes.title || 'Our Featured Classes'}</h2>
            <p className="section-description">
              {classes.description
                ? (() => { const lines = classes.description.split('\n'); return lines.map((line, i) => <span key={i}>{line}{i < lines.length - 1 && <br />}</span>); })()
                : <>Discover our premium fitness programs designed to challenge your limits<br />and unlock your true potential.</>}
            </p>
          </div>
          <div className="classes-grid">
            {Array.isArray(classes.items) && classes.items.length > 0
              ? classes.items.map((item, i) => (
                  <div key={i} className="class-card">
                    <div className="class-icon">{item.icon || '🏋️'}</div>
                    <h3 className="class-title">{item.title}</h3>
                    <p className="class-description">{item.description}</p>
                  </div>
                ))
              : (
                <>
                  <div className="class-card">
                    <div className="class-icon">🏋️</div>
                    <h3 className="class-title">Power Lifting</h3>
                    <p className="class-description">The Best Body Fitness in Town.</p>
                  </div>
                  <div className="class-card">
                    <div className="class-icon">💪</div>
                    <h3 className="class-title">Workout</h3>
                    <p className="class-description">Full-body fitness programs.</p>
                  </div>
                </>
              )}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">{cta.title || 'We Are Always Providing Best Fitness Service For You'}</h2>
            <button className="cta-btn" onClick={handleJoinTeam}>{cta.buttonText || 'JOIN OUR TEAM →'}</button>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">{siteName} {trainers.subtitleSuffix || 'Trainers'}</span>
            <h2 className="section-title">{trainers.title || 'Our Professional Training Staff'}</h2>
            <p className="section-description">
              {trainers.description
                ? (() => { const lines = trainers.description.split('\n'); return lines.map((line, i) => <span key={i}>{line}{i < lines.length - 1 && <br />}</span>); })()
                : <>Meet our dedicated trainers and their available schedules<br />for personalized fitness guidance.</>}
            </p>
          </div>
          <div className="trainers-grid">
            {Array.isArray(trainers.list) && trainers.list.length > 0
              ? trainers.list.map((trn, i) => (
                  <div key={i} className="trainer-card">
                    <div className="trainer-image">
                      <img src={trn.imageUrl || '/images/profile.jpg'} alt={`${trn.name} - ${trn.specialty || 'Trainer'}`} className="trainer-photo" />
                    </div>
                    <div className="trainer-info">
                      <h4 className="trainer-name">{trn.name}</h4>
                      <p className="trainer-specialty">{trn.specialty || 'Trainer'}</p>
                    </div>
                  </div>
                ))
              : (
                <>
                  <div className="trainer-card">
                    <div className="trainer-image"><img src="/images/mouzim.JPG" alt="Trainer" className="trainer-photo" /></div>
                    <div className="trainer-info"><h4 className="trainer-name">Mouzim</h4><p className="trainer-specialty">Trainer</p></div>
                  </div>
                  <div className="trainer-card">
                    <div className="trainer-image"><img src="/images/profile.jpg" alt="Trainer" className="trainer-photo" /></div>
                    <div className="trainer-info"><h4 className="trainer-name">Aqib</h4><p className="trainer-specialty">Trainer</p></div>
                  </div>
                </>
              )}
          </div>
        </div>
      </section>



      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{pricing.title || 'MEMBERSHIP LEVEL'}</h2>
            <p className="section-description">
              {pricing.description
                ? (() => { const lines = pricing.description.split('\n'); return lines.map((line, i) => <span key={i}>{line}{i < lines.length - 1 && <br />}</span>); })()
                : <>Choose the perfect membership plan that fits your lifestyle<br />and fitness goals.</>}
            </p>
          </div>
          <div className="pricing-toggle">
            <button className="toggle-btn">Monthly</button>
            <button className="toggle-btn">3 Months</button>
            <button className="toggle-btn">6 Months</button>
            <button className="toggle-btn">Annual</button>
          </div>
          {Array.isArray(pricing.categories) && pricing.categories.length > 0
            ? pricing.categories.map((cat, ci) => (
                <div key={ci} className="membership-categories">
                  <h3 className="category-title">{cat.title}</h3>
                  <div className="pricing-grid">
                    {(cat.plans || []).map((plan, pi) => (
                      <div key={pi} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
                        <h3 className="pricing-title">{plan.name}</h3>
                        <div className={`membership-badge ${plan.featured ? 'popular' : ''}`}>{plan.badge}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            : (
              <>
                <div className="membership-categories">
                  <h3 className="category-title">Membership Level (A)</h3>
                  <div className="pricing-grid">
                    <div className="pricing-card"><h3 className="pricing-title">Student Membership</h3><div className="membership-badge">Level A</div></div>
                    <div className="pricing-card"><h3 className="pricing-title">Adult Membership</h3><div className="membership-badge">Level A</div></div>
                  </div>
                </div>
                <div className="membership-categories">
                  <h3 className="category-title">Membership Level (B)</h3>
                  <div className="pricing-grid">
                    <div className="pricing-card featured"><h3 className="pricing-title">Individual Membership</h3><div className="membership-badge popular">Level B</div></div>
                    <div className="pricing-card"><h3 className="pricing-title">Premium Membership</h3><div className="membership-badge">Level B</div></div>
                  </div>
                </div>
              </>
            )}
          <div className="payment-info">
            <h4>Payment Methods</h4>
            <p>{pricing.paymentInfo || '💳 Cash Payment | 📱 Online Transfer'}</p>
          </div>
        </div>
      </section>

      {/* Become Trainer Section */}
      <section className="become-trainer-section">
        <div className="container">
          <div className="trainer-cta">
            <h2>{becomeTrainer.title || 'Become A Trainer'}</h2>
            <p>{becomeTrainer.description ? (() => { const lines = becomeTrainer.description.split('\n'); return lines.map((line, i) => <span key={i}>{line}{i < lines.length - 1 && <br />}</span>); })() : <>Join our elite team of fitness professionals and help others<br />transform their lives through the power of fitness.</>}</p>
            <button className="cta-btn" onClick={handleBecomeTrainer}>{becomeTrainer.buttonText || 'JOIN OUR TEAM →'}</button>
          </div>
        </div>
      </section>

      {/* Contact Us Section */}
      <section id="contact" className="contact-section">
        <Box sx={{ 
          py: 8,
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
        }}>
          <Container maxWidth="lg">
            {/* Header */}
            <Box textAlign="center" mb={6}>
              <Typography 
                variant="overline" 
                color="primary" 
                sx={{ fontWeight: 600, letterSpacing: 2 }}
              >
                GET IN TOUCH
              </Typography>
              <Typography 
                variant="h2" 
                component="h2" 
                sx={{ 
                  color: 'white', 
                  fontWeight: 700, 
                  mb: 2,
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}
              >
                {contact.heading || 'Contact Us'}
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  color: 'rgba(255,255,255,0.8)', 
                  maxWidth: 600, 
                  mx: 'auto',
                  fontSize: '1.1rem'
                }}
              >
                {contact.subtitle || "Reach out to us for any inquiries about our gym, classes, or membership plans. We're here to help you on your fitness journey."}
              </Typography>
            </Box>

            <Grid container spacing={3} justifyContent="center">
              {/* Contact Information */}
              <Grid item xs={6} md={3}>
                <Card sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  boxShadow: '0 20px 40px rgba(102, 126, 234, 0.3)',
                  border: 'none',
                  color: 'white',
                  position: 'relative',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    zIndex: 1
                  }
                }}>
                  <CardContent sx={{ p: 3, position: 'relative', zIndex: 2 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      mb: 3,
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: 2,
                      p: 1.5,
                      backdropFilter: 'blur(10px)'
                    }}>
                      <Box sx={{ 
                        background: 'rgba(255,255,255,0.3)',
                        borderRadius: '50%',
                        p: 1,
                        mr: 2
                      }}>
                        <LocationOn sx={{ fontSize: 28, color: 'white' }} />
                      </Box>
                      <Typography variant="h5" component="h3" sx={{ fontWeight: 700, fontSize: '1.3rem' }}>
                        {contact.addressTitle || 'Our Location'}
                      </Typography>
                    </Box>
                    <Box sx={{ 
                      background: 'rgba(255,255,255,0.15)',
                      borderRadius: 3,
                      p: 2.5,
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)'
                    }}>
                      {Array.isArray(contact.addressLines) && contact.addressLines.length > 0
                        ? contact.addressLines.map((line, i) => (
                            <Typography key={i} variant="body1" sx={{ mb: 1, opacity: i === 0 ? 1 : 0.9, fontWeight: i === 0 ? 600 : 400, fontSize: i === 0 ? '1.1rem' : '1rem', color: i === contact.addressLines.length - 1 ? '#FFD700' : 'inherit' }}>
                              {line}
                            </Typography>
                          ))
                        : (
                          <>
                            <Typography variant="body1" sx={{ mb: 1.5, fontWeight: 600, fontSize: '1.1rem' }}>De Muscle Factory Gym</Typography>
                            <Typography variant="body1" sx={{ mb: 1, opacity: 0.9 }}>Habak Naseem Bagh</Typography>
                            <Typography variant="body1" sx={{ mb: 1, opacity: 0.9 }}>Near Owais karni Masjid</Typography>
                            <Typography variant="body1" sx={{ mb: 1, opacity: 0.9 }}>Srinagar, Jammu and Kashmir</Typography>
                            <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.1rem', color: '#FFD700' }}>190006</Typography>
                          </>
                        )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Contact Details */}
              <Grid item xs={6} md={3}>
                <Card sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  boxShadow: '0 20px 40px rgba(245, 87, 108, 0.3)',
                  border: 'none',
                  color: 'white',
                  position: 'relative',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                    zIndex: 1
                  }
                }}>
                  <CardContent sx={{ p: 3, position: 'relative', zIndex: 2 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      mb: 3,
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: 2,
                      p: 1.5,
                      backdropFilter: 'blur(10px)'
                    }}>
                      <Box sx={{ 
                        background: 'rgba(255,255,255,0.3)',
                        borderRadius: '50%',
                        p: 1,
                        mr: 2
                      }}>
                        <Phone sx={{ fontSize: 28, color: 'white' }} />
                      </Box>
                      <Typography variant="h5" component="h3" sx={{ fontWeight: 700, fontSize: '1.3rem' }}>
                        Contact Information
                      </Typography>
                    </Box>
                    <Box sx={{ 
                      background: 'rgba(255,255,255,0.15)',
                      borderRadius: 3,
                      p: 2.5,
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)'
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                        <Box sx={{ 
                          background: 'rgba(255,255,255,0.3)',
                          borderRadius: '50%',
                          p: 0.8,
                          mr: 2
                        }}>
                          <Phone sx={{ fontSize: 20, color: 'white' }} />
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {contact.phone || '9419445026, 7006117955'}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2.5 }}>
                        <Box sx={{ 
                          background: 'rgba(255,255,255,0.3)',
                          borderRadius: '50%',
                          p: 0.8,
                          mr: 2
                        }}>
                          <Email sx={{ fontSize: 20, color: 'white' }} />
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {contact.email || 'info@demusclefactory.com'}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ 
                          background: 'rgba(255,255,255,0.3)',
                          borderRadius: '50%',
                          p: 0.8,
                          mr: 2
                        }}>
                          <LocationOn sx={{ fontSize: 20, color: 'white' }} />
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {contact.hours || '5:00 AM - 11:00 PM'}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Contact Form */}
              <Grid item xs={12} md={6}>
                <Paper sx={{ 
                  p: 4,
                  background: 'rgba(255,255,255,0.95)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: 3,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
                }}>
                  <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    Send us a Message
                  </Typography>

                  {submitStatus === 'success' && (
                    <Alert severity="success" sx={{ mb: 3 }}>
                      <Typography variant="h6">Thank you for your message!</Typography>
                      <Typography variant="body2">
                        We've received your inquiry and will get back to you soon.
                      </Typography>
                    </Alert>
                  )}

                  {submitStatus === 'error' && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                      <Typography variant="h6">Something went wrong</Typography>
                      <Typography variant="body2">
                        Please try again or contact us directly via phone or email.
                      </Typography>
                    </Alert>
                  )}

                  <Box component="form" onSubmit={handleSubmitMessage} sx={{ mt: 2 }}>
                    <TextField
                      fullWidth
                      label="Your Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      margin="normal"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(0,0,0,0.2)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'primary.main',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'primary.main',
                          },
                        },
                      }}
                    />

                    <Box sx={{ mt: 2, mb: 1 }}>
                      <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: 'text.secondary' }}>
                        Inquiry Type *
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Chip
                          label="General Inquiry"
                          onClick={() => handleInputChange({ target: { name: 'inquiryType', value: 'general' } })}
                          color={formData.inquiryType === 'general' ? 'primary' : 'default'}
                          variant={formData.inquiryType === 'general' ? 'filled' : 'outlined'}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: formData.inquiryType === 'general' ? 'primary.main' : 'rgba(59, 130, 246, 0.1)',
                            }
                          }}
                        />
                        <Chip
                          label="Become a Trainer"
                          onClick={() => handleInputChange({ target: { name: 'inquiryType', value: 'trainer' } })}
                          color={formData.inquiryType === 'trainer' ? 'primary' : 'default'}
                          variant={formData.inquiryType === 'trainer' ? 'filled' : 'outlined'}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: formData.inquiryType === 'trainer' ? 'primary.main' : 'rgba(59, 130, 246, 0.1)',
                            }
                          }}
                        />
                        <Chip
                          label="Join Our Team"
                          onClick={() => handleInputChange({ target: { name: 'inquiryType', value: 'team' } })}
                          color={formData.inquiryType === 'team' ? 'primary' : 'default'}
                          variant={formData.inquiryType === 'team' ? 'filled' : 'outlined'}
                          sx={{
                            cursor: 'pointer',
                            '&:hover': {
                              backgroundColor: formData.inquiryType === 'team' ? 'primary.main' : 'rgba(59, 130, 246, 0.1)',
                            }
                          }}
                        />
                      </Box>
                    </Box>
                    
                    <TextField
                      fullWidth
                      label="Your Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      margin="normal"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(0,0,0,0.2)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'primary.main',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'primary.main',
                          },
                        },
                      }}
                    />
                    
                    <TextField
                      fullWidth
                      label="Your Phone"
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      margin="normal"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(0,0,0,0.2)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'primary.main',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'primary.main',
                          },
                        },
                      }}
                    />
                    
                    <TextField
                      fullWidth
                      label="Your Message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      margin="normal"
                      variant="outlined"
                      multiline
                      rows={4}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(0,0,0,0.2)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'primary.main',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'primary.main',
                          },
                        },
                      }}
                    />
                    
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      size="large"
                      disabled={isSubmitting}
                      startIcon={isSubmitting ? null : <Send />}
                      sx={{ 
                        mt: 3, 
                        mb: 2,
                        py: 1.5,
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 8px 25px rgba(59, 130, 246, 0.4)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </section>



    



      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <p>&copy; 2025 {siteName}. All Rights Reserved. </p>
            <div className="developer-credit">
              <p>Developed by <a href="https://www.instagram.com/wahdatkashmiri/" target="_blank" rel="noopener noreferrer" className="developer-link">Wahdat Jan <Instagram className="instagram-icon" /></a></p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
